import script from "./InfonoisePost.vue?vue&type=script&setup=true&lang=js"
export * from "./InfonoisePost.vue?vue&type=script&setup=true&lang=js"

import "./InfonoisePost.vue?vue&type=style&index=0&id=45e47892&lang=scss"

const __exports__ = script;

export default __exports__